if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', afterDOMLoaded);
} else {
    afterDOMLoaded();
}

 function afterDOMLoaded() {
    try { setTimeout(mobileNavigationButtons, 500); } catch (err) { console.error('error in custom.js mobileNavigationButtons, err: ', err); }

 }

/* Klaviyo BIS Styling */

  // Function to change the contents of the existing <style> element
function changeStyleContents() {
    var styleElement = $("#klaviyo-bis-iframe").contents().find("head").find("style");
    styleElement.append(".modal-title {font-weight:700 !important; line-height:1.1 !important; text-align:center !important;} #container p { font-size: 16px; margin: 16px; text-align:center;}.control-group .btn {text-transform: uppercase; letter-spacing: 0.1em; font-weight: 600; font-size: 16px;} .btn:hover { background: #9b2700; color: white; border-color: #9b2700;}");
}

window.addEventListener('load', function () {
    if ($("#klaviyo-bis-iframe").length) {
        $("#klaviyo-bis-iframe").on("load", function () {
            changeStyleContents();
        });
    }
})

// Product image initialization handler
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 768) {
    console.log('Window width is <= 768, proceeding with mobile initialization');
    function showFirstSlide() {
      
      // Target all slides of both types
      const startingSlides = document.querySelectorAll('.product-main-slide.starting-slide');
      const secondarySlides = document.querySelectorAll('.product-main-slide.secondary-slide');
      
      // Apply opacity to all slides
      startingSlides.forEach(slide => {
        slide.style.opacity = '1';
      });
      
      secondarySlides.forEach(slide => {
        slide.style.opacity = '1';
      });
    }

    // Try multiple events
    document.addEventListener('shopify:section:load', showFirstSlide);
    document.addEventListener('recommendations:loaded', showFirstSlide);
    
    // Try immediately and with a shorter delay
    showFirstSlide();
    setTimeout(showFirstSlide, 100);
    
    // Check more frequently but for a shorter time
    let attempts = 0;
    const checkInterval = setInterval(() => {
      showFirstSlide();
      attempts++;
      if (attempts >= 5) {
        clearInterval(checkInterval);
      }
    }, 100);
  }
});

// Fix PhotoSwipe closing animation
theme.Photoswipe.prototype.initGallery = function(items, index) {
  var pswpElement = document.querySelectorAll('.pswp')[0];
  var initialBounds = null;

  var options = {
    allowPanToNext: false,
    captionEl: false,
    closeOnScroll: false,
    counterEl: false,
    history: false,
    index: index - 1,
    pinchToClose: false,
    preloaderEl: false,
    scaleMode: 'zoom',
    shareEl: false,
    showAnimationDuration: 250,
    hideAnimationDuration: 250,
    showHideOpacity: false,
    getThumbBoundsFn: function(index) {
      var currentSlide = document.querySelector('.product-main-slide.is-selected');
      if (!currentSlide) return null;

      var sliderImage = currentSlide.querySelector('img.photoswipe__image');
      if (!sliderImage) return null;

      var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      var rect = sliderImage.getBoundingClientRect();
      
      // If we're opening, store the position
      if (!initialBounds) {
        initialBounds = {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
        return initialBounds;
      }
      
      // If we're closing, use the stored position
      return initialBounds;
    }
  };

  this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
  // Reset initialBounds when gallery is closed
  this.gallery.listen('destroy', function() {
    initialBounds = null;
  });

  // Ensure main slider image stays visible during close
  this.gallery.listen('beforeClose', function() {
    var currentSlide = document.querySelector('.product-main-slide.is-selected');
    if (currentSlide) {
      currentSlide.style.visibility = 'visible';
      currentSlide.style.opacity = '1';
    }
  });

  this.gallery.init();
}

/**
 * Change Tab Index Attribute of Mobile Navigation Dropdowns
 */
function mobileNavigationButtons() {
    const dropdownButtons = document.querySelectorAll('div.mobile-nav__toggle button.collapsible-trigger');
    if (dropdownButtons) {
        dropdownButtons.forEach(dropdownButton => {
        dropdownButton.setAttribute('tabindex', '0');
        })
    }
}